import type { TViolationType } from "../../interfaces/statues";
import type { IState } from "../helpers";

// The engine and the next-availability prediction must make the same split-completion decision.
// Keep this module dependency-neutral: importing splitSb/shared.ts would traverse hosCalculator.
export const SPLIT_BLOCKING_VIOLATIONS: readonly TViolationType[] = ["Workday", "Driving", "Duty"];

export const isSplitCompleteBlockedByViolation = (state: IState): boolean =>
    SPLIT_BLOCKING_VIOLATIONS.some(violationType => violationType in state.currentViolations) ||
    state.emergencyResponseSuppressedViolations.some(violationType => SPLIT_BLOCKING_VIOLATIONS.indexOf(violationType) !== -1);
